<template>
  <div class="part">
    <!--number-->
    <div class="number">03</div>
    <div class="bg-right"></div>
    <div class="con">
      <div class="title">四大核心能力与技术</div>
      <div class="mark">全面赋能企业营销</div>
      <!--列表-->
      <ul class="list">
        <li class="item">
          <div class="icon icon1"></div>
          <div class="item-t">
            <div class="strong">小程序名片</div>
            <div class="small">营销社交化</div>
          </div>
          <div class="text">
            <div class="text-item">配备流动大数据，创建小名片只用7秒</div>
            <div class="text-item">不只是一张名片，更是连接企业和客户的连接器</div>
            <div class="text-item">名片直达公司官网，告别搜索竞价排名</div>
            <div class="text-item">客户存储的不只是名片，还自动保存个人和公司信息</div>
          </div>
        </li>
        <!--02-->
        <li class="item">
          <div class="icon icon2"></div>
          <div class="item-t">
            <div class="strong">智能获客</div>
            <div class="small">销售智能化</div>
          </div>
          <div class="text">
            <div class="text-item">云技术流定，弹性云满足用户动态增长，支持全渠道获客户，全场景使用，连接微信10亿流量</div>
            <div class="text-item">线上线下场景营销利器</div>
            <div class="text-item">客户通过扫描二维码，可以看见销售人员的个人信息、产品信息、公司信息和商城信息</div>
          </div>
        </li>
        <!--03-->
        <li class="item">
          <div class="icon icon3"></div>
          <div class="item-t">
            <div class="strong">客户管理</div>
            <div class="small">管理简单化</div>
          </div>
          <div class="text">
            <div class="text-item">管理升级，随时掌握销售动态，实时同步客户进展</div>
            <div class="text-item">雷达实时推送客户动态，AI算法不错过每个商机</div>
            <div class="text-item">智能分析客户兴趣和活跃度，智能数据挖掘高度意向客户</div>
            <div class="text-item">离职员工一键完成工作交接，公司客户永不流失</div>
          </div>
        </li>
        <!--04-->
        <li class="item">
          <div class="icon icon4"></div>
          <div class="item-t">
            <div class="strong">人人销售</div>
            <div class="small">销售人人化</div>
          </div>
          <div class="text">
            <div class="text-item">极简轻量化设计，支持企业VI统一，小官网行业模板多样化，手机端、移动端双模编辑</div>
            <div class="text-item">开启全员社交流量变现，为企业增加新的获客宣传渠道</div>
            <div class="text-item">全员分享小名片直达企业官网、产品、服务的展现</div>
          </div>
        </li>

      </ul>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.part{
  width: 100%;
  margin: 24px auto 0;
  min-width: $min-width;
  max-width: 1198px;
  line-height: 1.0;
  position: relative;
  .number{
    font-size: 180px;
    color:$theme-color;
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: -176px;
    font-weight: bold;
    @media screen and (min-width: $min-width) and (max-width: 1200px) {
      left: 10px;

    }
  }
  .bg-right{
    width: 361px;
    height: 633px;
    background-image: url("../../assets/images/index3bg.png");
    position: absolute;
    top: -270px;
    right: -364px;
  }
  .con{
    position: relative;
    z-index: 1;
    padding-top: 18px;
    .title{
      font-size: 48px;
      color:$theme-color;
      font-weight: bold;
      margin-bottom: 32px;
      padding-left: 16px;
    }
    .mark{
      font-size: 36px;
      color: #2cbb58;
      margin-bottom: 120px;
      padding-left: 16px;
    }
    .list{
      @include clearfix;
      .item{
        width: percent(250);
        float: left;
        & + .item{
          margin-left: percent(66);
        }
        padding: 16px 16px 46px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        .icon{
          width: 160px;
          height: 160px;
          margin: 0 auto 32px;
          @include bg-center;
        }
        .icon1{
          background-image: url("../../assets/images/03chatu1.png");
        }
        .icon2{
          background-image: url("../../assets/images/03chatu2.png");
        }
        .icon3{
          background-image: url("../../assets/images/03chatu3.png");
        }
        .icon4{
          background-image: url("../../assets/images/03chatu4.png");
        }
        .item-t{
          text-align:center;
          position: absolute;
          top: 208px;
          @include horizontal-center;
          transition: top 0.6s;
          .strong{
            font-size: 30px;
            margin-bottom: 36px;
            margin-top: 32px;
            font-weight: bold;
            color:#666;
            word-break: keep-all;
          }
          .small{
            font-size: 22px;
            color:#666;
          }
        }
        .text{
          opacity: 0;
          transition: opacity 0.4s, transform 0.6s;
          transform: translate(0, -40px);
          .text-item{
            font-size: 16px;
            color:#999;
            line-height: 1.6;
            padding-left: 14px;
            position: relative;
            &::after{
              content: '';
              display: block;
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: $theme-color;
              position: absolute;
              left: 0;
              top: 13px;
            }
          }
        }

        &:hover{
          box-shadow: 0 0 10px rgba(0,0,0,.2);
          .text{
            opacity: 1.0;
            transform: translate(0, 0);
          }
          .item-t{
            position: absolute;
            top: 20px;
            .strong{
              color: $theme-color;
            }
          }
          .icon{
            opacity: 0.1;

          }
        }


      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexPartThree.vue